import { useTranslation } from 'react-i18next';
import ProfileAvatarForm from '@/components/Forms/ProfileAvatarForm';
import { getFullname, getNameInitials } from '@/helpers/utils';
import { updateProfilePhoto } from '@/store/services/userServices';
import { cropAvatar } from '@/components/AvatarEdit';
import { uploadPhoto } from '@/store/services/commonServices';
import { useGetMe } from '@/hooks/useGetMe';

const ProfileAvatarModal = ({ onClose }) => {
  const { profile: user, refetchProfile } = useGetMe();
  const { t } = useTranslation('modal');

  const onSubmit = async (data, _, editorRef) => {
    try {
      if (data.file && editorRef) {
        const croppedAvatar = cropAvatar(editorRef);
        const response = await uploadPhoto(croppedAvatar);
        if (response && response.success) {
          const res = await updateProfilePhoto(response.data.id);
          if (res && res.success) {
            refetchProfile();
            onClose();
          }
        }
      }
    } catch (e) {}
  };

  const onRemove = async () => {
    try {
      const res = await updateProfilePhoto(null);
      if (res && res.success) {
        refetchProfile();
        onClose();
      }
    } catch (e) {}
  };

  if (!user) {
    return <div style={{ padding: '70px 50px' }}>{t('load_image_error')}</div>;
  }

  return (
    <ProfileAvatarForm
      photo={user.photo}
      fullname={getFullname(user.first_name, user.last_name)}
      nameInitials={getNameInitials(user.first_name, user.last_name)}
      onSubmit={onSubmit}
      onRemove={onRemove}
    />
  );
};

export default ProfileAvatarModal;
